import AccountProfile from './AccountProfile';

export default AccountProfile;
